import { render, staticRenderFns } from "./ChecklistsChecklistItem.vue?vue&type=template&id=1b83f5fa&scoped=true"
import script from "./ChecklistsChecklistItem.vue?vue&type=script&lang=js"
export * from "./ChecklistsChecklistItem.vue?vue&type=script&lang=js"
import style0 from "./ChecklistsChecklistItem.vue?vue&type=style&index=0&id=1b83f5fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b83f5fa",
  null
  
)

export default component.exports